import { ExerciseState, ExerciseStateMap, TypeArray } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"
import {
  processActionMeta,
  getObjectMapTypeReducerGuard
} from "../reducers"

export type ElementState = {
  exercises: ExerciseStateMap
}

export const reducerAction = {
  exercises: actionCreatorTypeGuard<ElementState, ExerciseStateMap>(
    "exercises",
    "ElementState"
  ),
  __record: actionCreatorTypeGuard<TypeArray, ElementState>(
    "ElementState",
    "__record"
  ),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<ElementState>>(
    "create",
    "__create/ElementState"
  ),
  __null: actionCreatorTypeGuard<TypeArray, null>("null", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof ElementState
    | "__record"
    | "__null"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const elementStateAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

const validationOptions = {
  strict: true,
  abortEarly: false,
  stripUnknown: true,
  recursive: true
}

export const elementStateReducer = reducerTypeGuard<ElementState>().default(
  (prevState, action: any) => {
    action = processActionMeta(action)

    const {
      prop,
      idx,
      nodes
    }: { prop: keyof ElementState; idx: number; nodes: Array<any> } =
      action?.meta

    switch (action?.meta?.prop) {
      case "exercises":
        return getObjectMapTypeReducerGuard<
          ElementState,
          ExerciseStateMap,
          ExerciseState
        >("exercises", "exercises", "ExerciseState", prevState, action)
    }

    return prevState
  }
)
